import { post } from '@/helpers/HttpHelper'

export class CategoriaService {
  async getMarcas () {
    const response = await post('/filtro/marcas', {})
    return response.data.data
  }

  async getLineas () {
    const response = await post('/filtro/lineas', {})
    return response.data.data
  }

  async getCategorias (codigo) {
    const response = await post('/filtro/categorias', codigo)
    return response.data.data
  }

  async getMenuCategorias (codigo) {
    const response = await post('/filtro/get_menu_categoria', codigo)
    return response.data.data
  }
}
